function is_false(boolean_test) {
    return (boolean_test + "" === false + "");
}
export default is_false;
